import Vue from 'vue'
Vue.directive('noScroll', {
  inserted(el, binding) {
    var fragment = document.createDocumentFragment()
    var oScrollWrap = document.createElement('div')
    var oScroll = document.createElement('div')
    var oParent = null;
    oParent = el.parentNode
    oScrollWrap.setAttribute('style', 'overflow: hidden;width: 100%;')
    oScroll.setAttribute('style', `margin-right: ${binding.value || -18}px;`)
    fragment.appendChild(oScrollWrap)
    oScrollWrap.appendChild(oScroll)
    oParent.insertBefore(fragment, el)
    oScroll.appendChild(el)
  }
});


// WEBPACK FOOTER //
// ./src/directive/no-scroll/directives.js